<div class="rs-txt-c2">
  <p>
    {{ 'option.order.confirmation.message.' + netflixBuyAndSellStatus + '.title' | translate }}
  </p>
  <h2
    *ngIf="netflixBuyAndSellStatus == NetflixBuyAndSellStatus.AVAILABLE"
    id="confirmModalTitle"
    class="rs-txt-c2"
  >
    {{ packDescription }}
  </h2>
  <p class="lead">
    {{ 'option.order.confirmation.message.' + netflixBuyAndSellStatus + '.content' | translate }}
  </p>
  <div class="rs-me"></div>
  <button class="rs-btn rs-btn-order rs-btn-wide-so" (click)="close()">
    {{ 'option.order.confirmation.message.' + netflixBuyAndSellStatus + '.button' | translate }}
  </button>
</div>
